import { OnPremOrderStatus } from "../../../common/types/OnPremOrderStatus";

export const mapOrderStatusIcon: Record<OnPremOrderStatus, string> = {
    [OnPremOrderStatus.Encoded]: "FileCode",
    [OnPremOrderStatus.Recalled]: "ReminderTime",
    [OnPremOrderStatus.Ordered]: "Accept",
    [OnPremOrderStatus.PartialAssetAssigned]: "CircleHalfFull",
    [OnPremOrderStatus.AssetAssigned]: "Assign",
    [OnPremOrderStatus.OnHold]: "Blocked2",
    [OnPremOrderStatus.ReadyToSend]: "Accept",
    [OnPremOrderStatus.SentToOem]: "Send",
    [OnPremOrderStatus.Cancelled]: "ErrorBadge",
    [OnPremOrderStatus.Rejected]: "ErrorBadge"
};
